import { render, staticRenderFns } from "./TableRow.vue?vue&type=template&id=143dd246&scoped=true&"
import script from "./TableRow.vue?vue&type=script&lang=ts&"
export * from "./TableRow.vue?vue&type=script&lang=ts&"
import style0 from "./TableRow.vue?vue&type=style&index=0&id=143dd246&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143dd246",
  null
  
)

export default component.exports